import ProductBanner from './ProductBanner.vue'

export default ProductBanner
